import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage, numberSchemaWithTransform } from 'core/yup';

export const uomConversionSchema = () =>
  yup.object().shape({
    fromUom: yup
      .object()
      .label(t('labelBaseUom'))
      .nullable()
      .required(getEmptyErrorMessage(t('labelBaseUom'))),
    toUom: yup
      .string()
      .label(t('labelAlternateUom'))
      .nullable()
      .required(getEmptyErrorMessage(t('labelAlternateUom'))),
    multiplier: numberSchemaWithTransform()
      .label(t('labelMultiplier'))
      .nullable()
      .required(getEmptyErrorMessage(t('labelMultiplier'))),
  });

export const corporatePartUomSchema = () =>
  yup.object().shape({
    uom: yup.object().label(t('labelBaseUom')).required(),
    salesUom: yup.string().label(t('labelSales')).nullable(),
    alternateSalesUom: yup.string().label(t('labelAlternateSales')).nullable(),
    packageUom: yup.string().label(t('labelPackage')).nullable(),
    externalUom: yup.string().label(t('labelExternalErp')).nullable(),
    alternateUom: yup.string().label(t('labelSkuUom')).nullable(),
  });
